import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  deleteEmployeeSaga,
  editEmployeeSaga,
  employeeSaga,
  getEmployeeSaga,
} from "./saga";

export default function* watchEmployee() {
  yield takeLatest(actionTypes.SUBMIT_EMPLOYEE, employeeSaga);
  yield takeLatest(actionTypes.GET_EMPLOYEE_DETAILS, getEmployeeSaga);
  yield takeLatest(actionTypes.EDIT_EMPLOYEE, editEmployeeSaga);
  yield takeLatest(actionTypes.DELETE_EMPLOYEE, deleteEmployeeSaga);
}
